import gql from 'graphql-tag'

export const contactQuery = gql`
	query($contactFilter: ContactsFilter) {
		contactQuery: allContactses(filter: $contactFilter, orderBy: nameFirst_ASC) {
			id
			nameFirst
			nameLast
			birthDate
			birthPlace
			birthTime
			birthSigns
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/contacts.js